import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AlertComponent,
  CardBodyComponent,
  CardComponent,
  ColComponent,
  ContainerComponent,
  RowComponent,
  SpinnerComponent
} from '@coreui/angular-pro';

@Component({
  selector: 'app-kyc-token-page',
  standalone: true,
  imports: [
    CommonModule,
    AlertComponent,
    CardComponent,
    CardBodyComponent,
    ContainerComponent,
    RowComponent,
    ColComponent,
    SpinnerComponent
  ],
  templateUrl: './kyc-token-page.component.html',
  styles: [`
    :host {
      display: block;
      position: absolute;
      inset: 0;
      overflow-y: auto;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KycTokenPageComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private http = inject(HttpClient);

  loading = signal(true);
  error = signal<string | null>(null);

  constructor() {
    this.handleTokenVerification();
  }

  private handleTokenVerification(): void {
    const token = this.route.snapshot.params['token'];
    const action = this.route.snapshot.data['action'] as 'confirm' | 'correct';
    const lang = this.route.snapshot.parent?.params?.['lang'] || 'en';

    if (!token) {
      this.loading.set(false);
      this.error.set('Invalid link');
      return;
    }

    this.http.get(`/kyc/${action}/${token}`).subscribe({
      next: () => {
        this.loading.set(false);
        if (action === 'confirm') {
          this.router.navigate(['/', lang, 'kyc', 'confirmed']);
        } else {
          this.router.navigate(['/', lang, 'kyc']);
        }
      },
      error: (err) => {
        this.loading.set(false);
        this.error.set(err.error?.error || 'An error occurred.');
      }
    });
  }
}